import fetchApi from "../fetchApi";

export const GetUserEmail = async (emailToken) => {
    const options = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        redirect: 'follow'
    }

    return await fetchApi(`auth/register?pwt=${emailToken}`, options, true);

};